<template>
  <div>
    <div class="content">
      <div class="title">1.零工基本信息</div>
      <div class="text">
        零工发布成功后，招聘类型、零工名称、零工类型、工作城市，将无法修改
      </div>
      <div class="box">
        <div class="name">公司:</div>
        <div class="txt">{{ comInfo.trade_cn }} · {{ comInfo.name }}</div>
      </div>
      <div class="box">
        <div class="name mr5"><span style="color: red">*</span> 联系人:</div>
        <div class="inpBox">
          <input
            class="gkInp"
            v-model="person"
            type="text"
            placeholder="请输入联系人"
          />
          <div class="myBox" @click="nameShowClick">
            <div class="kuang dis-cent" :class="nameShow ? 'on' : ''">
              <div class="iconfont icon-right" v-if="nameShow"></div>
            </div>
            <div class="txt1" :class="nameShow ? 'txtOn' : ''">
              {{ nameShow ? "公开" : "不公开" }}
            </div>
          </div>
        </div>
      </div>
      <div class="box">
        <div class="name mr5"><span style="color: red">*</span> 联系方式:</div>
        <div class="inpBox">
          <input
            class="gkInp"
            v-model="mobile"
            type="text"
            placeholder="请输入联系方式"
          />
          <div class="myBox" @click="mobileShowClick">
            <div class="kuang dis-cent" :class="mobileShow ? 'on' : ''">
              <div class="iconfont icon-right" v-if="mobileShow"></div>
            </div>
            <div class="txt1" :class="mobileShow ? 'txtOn' : ''">
              {{ mobileShow ? "公开" : "不公开" }}
            </div>
          </div>
        </div>
      </div>
      <div class="box">
        <div class="name mr5"><span style="color: red">*</span>零工工种:</div>
        <a-dropdown>
          <div class="inpBox" :class="config_cn ? 'on' : ''">
            <div class="seleTxt">
              {{ typeData["零工工种"] ? config_cn : "请选择零工工种" }}
            </div>
            <div class="iconfont icon-enter enter"></div>
          </div>
          <a-menu
            slot="overlay"
            @click="hyClick"
            :selectedKeys="[typeData['零工工种']]"
          >
            <a-menu-item
              :key="'零工工种_' + item.id + '_' + item.name"
              v-for="item in gzTypeList"
              >{{ item.name }}</a-menu-item
            >
          </a-menu>
        </a-dropdown>
      </div>
      <div class="box">
        <div class="name mr5"><span style="color: red">*</span>零工名称:</div>
        <div class="inpBox">
          <input type="text" v-model="name" placeholder="请输入零工名称" />
        </div>
      </div>
      <div class="box">
        <div class="name mr5"><span style="color: red">*</span>零工描述:</div>
        <div class="tareBox">
          <textarea v-model="content" placeholder="请输入零工描述"></textarea>
        </div>
      </div>
      <div class="title">2.零工要求</div>
      <div class="text">
        我们将通过以下条件，为您精确推荐合适的人才，请尽量详细填写
      </div>
      <div class="box">
        <div class="name mr5"><span style="color: red">*</span>招聘人数:</div>
        <div class="inpBox">
          <input type="number" v-model="amount" placeholder="请输入招聘人数" />
        </div>
      </div>
      <div class="box">
        <div class="name mr5"><span style="color: red">*</span>结算周期:</div>
        <a-dropdown>
          <div class="inpBox" :class="result_cn ? 'on' : ''">
            <div class="seleTxt">
              {{ typeData["结算周期"] ? result_cn : "请选择结算周期" }}
            </div>
            <div class="iconfont icon-enter enter"></div>
          </div>
          <a-menu
            slot="overlay"
            @click="hyClick"
            :selectedKeys="[typeData['结算周期']]"
          >
            <a-menu-item
              :key="'结算周期_' + item.id + '_' + item.name"
              v-for="item in resultList"
              >{{ item.name }}</a-menu-item
            >
          </a-menu>
        </a-dropdown>
      </div>
      <div class="box">
        <div class="name mr5"><span style="color: red">*</span>计算方式:</div>
        <a-dropdown>
          <div class="inpBox" :class="way_cn ? 'on' : ''">
            <div class="seleTxt">
              {{ typeData["计算方式"] ? way_cn : "请选择计算方式" }}
            </div>
            <div class="iconfont icon-enter enter"></div>
          </div>
          <a-menu
            slot="overlay"
            @click="hyClick"
            :selectedKeys="[typeData['计算方式']]"
          >
            <a-menu-item
              :key="'计算方式_' + item.id + '_' + item.name"
              v-for="item in wayList"
              >{{ item.name }}</a-menu-item
            >
          </a-menu>
        </a-dropdown>
      </div>
      <div class="box">
        <div class="name mr5"><span style="color: red">*</span>薪资金额:</div>
        <div class="xzinpBox">
          <input type="number" v-model="price" placeholder="请输入薪资金额" />
          <div class="js">元/{{ way_id == 1 ? "件" : way_id == 2 ? "小时" : way_id == 3 ? "天" : "月"}}</div>
        </div>
      </div>
      <div class="box">
        <div class="name">工作地址:</div>
        <div class="txt">{{ comInfo.address }}</div>
      </div>
      <div class="fbBox">
        <div class="btn dis-cent" @click="saveClick">发布</div>
      </div>
    </div>
    <XuanzeLd v-if="ldShow" @show="ldShowJs" :ldData="ldData" />
  </div>
</template>

<script>
import XuanzeLd from "../../component/xuanzeLd.vue";
import { Menu, Form, Input, Dropdown, Upload, Icon } from "ant-design-vue";
export default {
  components: {
    "a-menu": Menu,
    "a-menu-item": Menu.Item,
    "a-sub-menu": Menu.SubMenu,
    "a-form": Form,
    "a-form-item": Form.Item,
    "a-input": Input,
    "a-dropdown": Dropdown,
    "a-textarea": Input.TextArea,
    "a-upload": Upload,
    "a-icon": Icon,
    XuanzeLd,
  },
  name: "",
  data() {
    return {
      ldData: [],
      ldShow: false,
      nameShow: true,
      mobileShow: true,
      config_id: 0,
      config_cn: "",
      gzTypeList: [],
      typeData: {
        零工工种: "",
        结算周期: "",
        计算方式: "",
      },
      result_id: "",
      result_cn: "",
      resultList: [
        {
          id: 1,
          name: "日结",
        },
        {
          id: 2,
          name: "周结",
        },
        {
          id: 3,
          name: "月结",
        },
      ],
      way_id: "",
      way_cn: "",
      wayList: [
        {
          id: 1,
          name: "按件计费",
        },
        {
          id: 2,
          name: "按小时计费",
        },
        {
          id: 3,
          name: "按天计费",
        },
        {
          id: 4,
          name: "按月计费",
        },
      ],
      person: "",
      mobile: "",
      name: "",
      content: "",
      amount: "",
      price: "",
      comInfo:{},
    };
  },
  props: ["id"],
  created() {
    this.typeGet();
    this.get();
    if (this.id) {
      this.bjget();
    }
  },
  methods: {
    bjget() {
      this.$get("/nozzle/web/odd_update_info", {
        id: this.id,
      }).then((res) => {
        console.log(res.data);
        let data = res.data;
        this.data = data;
        this.mobile = data.mobile;
        this.person = data.person;
        // 零工工种
        this.config_id = data.config_id;
        this.config_cn = data.linggong;
        this.typeData["零工工种"] =
          "零工工种_" + data.config_id + "_" + data.linggong;
        // 结算周期
        this.result_id = data.result;
        this.typeData["结算周期"] =
          "结算周期_" + data.result + "_" + (data.result == 1 ? "日结" : data.result == 2 ? "周结" : "月结");
        this.result_cn =
          data.result == 1 ? "日结" : data.result == 2 ? "周结" : "月结";
        // 计算方式
        this.way_id = data.way;
        this.typeData["计算方式"] = "计算方式_" + data.way + "_" + (data.way == 1 ? "按件计费" : data.way == 2 ? "按小时计费" : data.way == 3 ? "按天计费" : "按月计费");
        this.way_cn = data.way == 1 ? "按件计费" : data.way == 2 ? "按小时计费" : data.way == 3 ? "按天计费" : "按月计费";
        this.name = data.name;
        this.content = data.content;
        this.amount = data.amount;
        this.price = data.price;
        this.jpShow = data.is_worry == 1 ? true : false;
        this.nameShow = data.is_person == 1 ? true : false;
        this.mobileShow = data.is_mobile == 1 ? true : false;
      });
    },
    saveClick() {
      if (!this.person) {
        this.$message.error("请填写联系人");
        return;
      }
      if (!this.mobile) {
        this.$message.error("请填写联系方式");
        return;
      }
      if (!this.name) {
        this.$message.error("请输入零工名称");
        return;
      }
      if (!this.content) {
        this.$message.error("请输入零工描述");
        return;
      }
      if (!this.amount) {
        this.$message.error("请输入招聘人数");
        return;
      }
      if (!this.result_id) {
        this.$message.error("请选择结算周期");
        return;
      }
      if (!this.way_id) {
        this.$message.error("请选择计算方式");
        return;
      }
      if (!this.price) {
        this.$message.error("请输入薪资金额");
        return;
      }
      let info = {
        ...this.data,
        person: this.person,
        mobile: this.mobile,
        name: this.name,
        content: this.content,
        amount: Number(this.amount),
        price: Number(this.price),
        config_id: Number(this.config_id),
        config_cn: this.config_cn,
        way: Number(this.way_id),
        result: Number(this.result_id),
      };
      info.is_person = this.nameShow ? 1 : 2;
      info.is_mobile = this.mobileShow ? 1 : 2;
      info = JSON.stringify(info);
      this.$post("/nozzle/web/oddjob_save", {
        data: info,
      }).then((res) => {
        console.log(res);
        if (res.data.status == 1) {
          this.$router.back();
          this.$message.success("发布成功");
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    get() {
      this.$get("/nozzle/web/company_info").then((res) => {
        console.log(res);
        this.comInfo = res.data?res.data:{};
        if (!this.id) {
          this.person = res.data.person;
          this.mobile = res.data.mobile;
        }
      });
    },
    typeGet() {
      this.$get("/common/configuration_gets", {
        type: "linggong",
      }).then((res) => {
        this.gzTypeList = res.data;
      });
    },
    nameShowClick() {
      this.nameShow = !this.nameShow;
    },
    mobileShowClick() {
      this.mobileShow = !this.mobileShow;
    },
    hyClick(e) {
      let key = e.key.split("_");
      this.typeData[key[0]] = e.key;
      if (key[0] == "零工工种") {
        this.config_cn = key[2];
        this.config_id = key[1];
      }
      console.log(key);

      if (key[0] == "结算周期") {
        this.result_cn = key[2];
        this.result_id = key[1];
      }
      if (key[0] == "计算方式") {
        this.way_cn = key[2];
        this.way_id = key[1];
      }
    },
    ldShowJs(e) {
      this.ldData = e.data;
      this.ldShow = false;
    },
  },
  mounted() {},
  computed: {},
};
</script>
<style lang="less" scoped>
.content {
  .title {
    font-weight: 600;
    font-size: 20px;
    margin-bottom: 5px;
  }
  .text {
    color: #666;
    margin-bottom: 30px;
  }
  .box {
    display: flex;
    margin-bottom: 15px;
    .name {
      color: #666;
      width: 90px;
      text-align: right;
    }
    .mr5 {
      margin-top: 5px;
    }
    .txt {
      width: calc(100% - 90px);
      padding-left: 10px;
      box-sizing: border-box;
      font-size: 14px;
    }
    .inpBox {
      width: 500px;
      padding: 0 10px;
      height: 35px;
      margin-left: 10px;
      border-radius: 5px;
      box-sizing: border-box;
      border: 1px solid #ebebeb;
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: #9c9c9c;
      overflow: hidden;
      cursor: pointer;
      .seleTxt {
        width: calc(100% - 35px);
      }
      .enter {
        width: 35px;
        text-align: right;
        font-size: 14px;
      }
      input {
        width: 100%;
        height: 100%;
        color: #000;
      }
    }
    .on {
      color: #333;
    }
    .myBox {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 80px;
      cursor: pointer;
      .kuang {
        width: 18px;
        height: 18px;
        border-radius: 5px;
        border: 1px solid #c9c9c9;
      }
      .on {
        border: 1px solid #147ee0;
        background-color: #147ee0;
        color: #fff;
      }
      .txt1 {
        font-size: 14px;
        margin-left: 6px;
        color: #666;
      }
      .txtOn {
        color: #147ee0;
      }
    }
    .xzinpBox {
      width: 500px;
      height: 35px;
      margin-left: 10px;
      box-sizing: border-box;
      color: #9c9c9c;
      overflow: hidden;
      cursor: pointer;
      display: flex;
      align-items: flex-end;
      input {
        border: 1px solid #ebebeb;
        box-sizing: border-box;
        width: calc(100% - 70px);
        height: 100%;
        color: #000;
        border-radius: 5px;
        padding-left: 10px;
      }
      .js {
        margin-left: 10px;
        color: #000;
      }
    }
    .selectBoxs {
      width: 500px;
      height: 35px;
      display: flex;
      align-items: center;
      box-sizing: border-box;
      margin-left: 10px;
      .cont {
        width: calc(33.33% - 10px);
        height: 100%;
        display: flex;
        align-items: center;
        box-sizing: border-box;
        border: 1px solid #ebebeb;
        border-radius: 5px;
        padding: 0 10px;
        color: #9c9c9c;
        cursor: pointer;
        .seleTxt {
          width: calc(100% - 35px);
        }
        .enter {
          width: 35px;
          text-align: right;
          font-size: 14px;
        }
      }
      .cont:last-child {
        margin-right: 0;
      }
      .gang {
        width: 10px;
      }
      .cha {
        width: 20px;
        font-size: 16px;
        position: relative;
        top: -1px;
      }
    }
    .selectYearBoxs {
      width: 500px;
      height: 35px;
      display: flex;
      align-items: center;
      box-sizing: border-box;
      margin-left: 10px;
      .cont {
        width: calc(50% - 7.5px);
        margin-right: 15px;
        height: 100%;
        display: flex;
        align-items: center;
        box-sizing: border-box;
        border: 1px solid #ebebeb;
        border-radius: 5px;
        padding: 0 10px;
        color: #9c9c9c;
        cursor: pointer;
        .seleTxt {
          width: calc(100% - 35px);
        }
        .enter {
          width: 35px;
          text-align: right;
          font-size: 14px;
        }
      }
      .cont:last-child {
        margin-right: 0;
      }
    }
    .zwCont {
      display: flex;
      align-items: center;
      width: 500px;
      padding: 0 10px;
      height: 35px;
      margin-left: 10px;
      .addBox {
        width: 70px;
        height: 30px;
        border-radius: 30px;
        border: 1px solid #ebebeb;
        box-sizing: border-box;
        color: #9c9c9c;
        margin-right: 10px;
        cursor: pointer;
      }
      .zwBox {
        height: 30px;
        background-color: #e9effa;
        padding: 0 15px 0 20px;
        border-radius: 30px;
        margin-right: 10px;
        .close {
          font-size: 12px;
          font-weight: 600;
          position: relative;
          top: 1px;
          margin-left: 7px;
          cursor: pointer;
        }
      }
    }
    .tareBox {
      height: 160px;
      width: 500px;
      margin-left: 10px;
      border-radius: 5px;
      box-sizing: border-box;
      border: 1px solid #ebebeb;
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: #333;
      overflow: hidden;
      cursor: pointer;
      textarea {
        width: 100%;
        height: 100%;
        border: none;
        padding: 10px;
      }
    }
  }
  .fbBox {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .btn {
      width: 90px;
      height: 40px;
      border-radius: 5px;
      background-color: #147ee0;
      color: #fff;
      cursor: pointer;
    }
  }
}
</style>
